import { render, staticRenderFns } from "./procedures-page.vue?vue&type=template&id=2c26eb0a"
import script from "./procedures-page.vue?vue&type=script&lang=js"
export * from "./procedures-page.vue?vue&type=script&lang=js"
import style0 from "./procedures-page.vue?vue&type=style&index=0&id=2c26eb0a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports